// Generated by ReScript, PLEASE EDIT WITH CARE


function isAvailable() {
  try {
    let test = "__storage_test__";
    window.localStorage.setItem(test, test);
    window.localStorage.removeItem(test);
    return true;
  } catch (exn) {
    return false;
  }
}

let LocalStorage = {
  isAvailable: isAvailable
};

let Location = {};

let generateUUID = (function() {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        return window.crypto.randomUUID();
      }
      // Fallback for older browsers
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0;
        var v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    });

let Crypto = {
  generateUUID: generateUUID
};

let Window = {};

let DateUtils = {};

let Console = {};

let Clipboard = {};

let Document = {};

let Element = {};

export {
  LocalStorage,
  Location,
  Crypto,
  Window,
  DateUtils,
  Console,
  Clipboard,
  Document,
  Element,
}
/* No side effect */
